import { DashedDivider } from '@screens/review-section2/styles';
import { Title } from '@screens/review-section3/review/styles';
import { createTranslationService } from '@services/factories';
import { StringFormatService } from '@services/StringFormatService';
import {
    Flexible,
    Row
} from '@styles/shared-styles';
import { cacheTranslations } from '@utils/cache-translations';
import {
    DateFormatTemplate,
    formatAsUTC
} from '@utils/date-format';
import { observer } from 'mobx-react';
import * as React from 'react';
import { HorizontalLayoutRow } from './styles';

enum FormI9HeaderTranslation {
    employmentEligibilityVerification = 'employmentEligibilityVerification',
    uscis = 'uscis',
    departmentOfHomelandSecurity = 'departmentOfHomelandSecurity',
    formI9 = 'formI9',
    usCitizenshipAndImmigrationServices = 'usCitizenshipAndImmigrationServices',
    ombNumber = 'ombNumber',
    expirationDate = 'expirationDate',
    expirationDateTemplate = 'expirationDateTemplate'
}

// Not sure what the best approach is when this form expires
// should we version the forms via expiry date/id?
const defaultFormExpiry = '2022-10-31';
const FormI9Header: React.FunctionComponent<{
    formExpiryDate?: string;
}> = (props) => {
    const {
        formExpiryDate = defaultFormExpiry
    } = props;

    const translations = cacheTranslations(
        createTranslationService(),
        FormI9HeaderTranslation,
        'i9FormHeader'
    );

    return (
        <div>
            <DashedDivider/>
            <HorizontalLayoutRow innerSpacing={'medium'}>
                <Flexible>
                    <Title>
                        {translations.employmentEligibilityVerification}
                    </Title>
                </Flexible>
                <Title>
                    {translations.uscis}
                </Title>
            </HorizontalLayoutRow>
            <HorizontalLayoutRow innerSpacing={'medium'}>
                <Flexible>
                    <Title>
                        {translations.departmentOfHomelandSecurity}
                    </Title>
                </Flexible>
                <Title>
                    {translations.formI9}
                </Title>
            </HorizontalLayoutRow>
            <Row>
                <Flexible>{translations.usCitizenshipAndImmigrationServices}</Flexible>
                <div>
                    <div>{translations.ombNumber}</div>
                    {/* Uncomment if we leave the expiration date in resources */}
                    {/*<div>{translations.expirationDate}</div>*/}
                    <div>{StringFormatService.format(translations.expirationDateTemplate, [
                        formatAsUTC(formExpiryDate, DateFormatTemplate.MonthFirstCalendarDate)
                    ])}</div>
                </div>
            </Row>
        </div>
    );
};

export default observer(FormI9Header);



// WEBPACK FOOTER //
// ./src/containers/form-i9/form-header.tsx